var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Snackbars',{attrs:{"messages":_vm.notifications.notificationsList,"id-key":"id","color-key":"type","text-key":"message","timeout":"5000","top":"","right":""},on:{"remove":_vm.notificationsRemove}})}
var staticRenderFns = []

export { render, staticRenderFns }